import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/postage-stamps")({
	component: PostageStampsLayout,
})

function PostageStampsLayout() {
	return <Outlet />
}
